
import { useTranslation } from 'react-i18next';

const HotelCard = ({ hotel, ruta, lang, config, adultos, ninos, llegada, salida, moneda }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const caracteristicasAleatorias = [...hotel.caracteristicas].sort(() => Math.random() - 0.5).slice(0, 3);

    return (

        <div>
            <div className="c-card-shadow c-card-shadow_hotel">
                <figure className="c-card-shadow_img">
                    {
                        hotel.foto_principal && hotel.foto_principal.length != 0 ?
                            <img src={ruta + "/propiedades/" + hotel.id + "/fotos/web/" + hotel.foto_principal[0].nombre} />
                            :
                            <img src="/images/web/bedloop-nofoto.png" />
                    }
                </figure>
                <div className="c-card-shadow_body">
                    <div className="c-card-shadow_header">
                        <div className="flex-wrap gap-2 d-flex align-items-center">
                            <h3 className="mb-0 h5 text-md font-body">
                                <a href={"/" + preidioma + t("apartamentos") + "-" + hotel.destino.url_dinamica[lang] + "/" + hotel.url_dinamica}>{hotel.nombre_traducido && hotel.nombre_traducido[lang] ? hotel.nombre_traducido[lang] : hotel.nombre}</a>
                            </h3>
                        </div>
                        <ul className="o-list-tags">
                            <li>{hotel.destino.nombre[lang]}</li>
                        </ul>
                    </div>
                    <p className="c-card-shadow_location">
                        <i className="fa-solid fa-location-dot" style={{ paddingRight: "10px" }}></i>{hotel.calle ? hotel.calle : "-"}
                    </p>
                    <p className="c-card-shadow_location d-md-none">
                        <i className="fa-solid fa-phone" style={{ paddingRight: "10px" }}></i>{config.telefono_fiscal}
                    </p>
                    <div className="gap-1 mb-2 text-xxs d-flex align-items-center">

                        <i className="fa-solid fa-location-dot" style={{ paddingRight: "10px" }}></i>
                        <div>
                            <div className="d-flex align-items-center">
                                <span className="o-rating full"></span>
                                <span className="o-rating full"></span>
                                <span className="o-rating full"></span >
                                <span className="o-rating full"></span>
                                <span className="o-rating full"></span>
                            </div >
                        </div>
                        <span>{hotel.comentarios.length >= 1 ? hotel.comentarios.length : "1"} reviews</span>
                    </div >

                    <div>
                        <ul className="style-list" style={{ listStyle: "disc" }} >
                            {
                                caracteristicasAleatorias.map((carac) => (
                                    <li className="mb-2" key={carac.id}>
                                        {carac.nombre[lang]}
                                    </li>
                                ))
                            }
                        </ul >
                    </div >
                    <div className="flex-wrap gap-2 d-flex justify-content-end align-items-end c-card-shadow_footer">
                        {(adultos && llegada && salida) ?
                            <p className="mb-0 w-100 text-sm-end">{t("Desde")}<strong className="text-lg fw-semibold"> {(hotel.precio / 100).toFixed(2) + moneda} </strong> / {t("noche")} </p >
                            :
                            <p className="mb-0 w-100 text-sm-end">{""}</p >
                        }
                        <a className="btn btn-outline-primary" href={"/" + preidioma + t("apartamentos") + "-" + hotel.destino.url_dinamica[lang] + "/" + hotel.url_dinamica} > {t("Más información")}</a>
                        {(adultos && llegada && salida) ?
                            <a className="btn btn-primary" href={`/${preidioma}${t("reserva")}?idpropiedad=${hotel.id}&entrada=${llegada.replaceAll("-", "/")}&salida=${salida.replaceAll("-", "/")}&adultos=${Number(adultos)}&ninos=${Number(ninos)}&bebes=0&solorequest=0`} >{t("Reserva")}</a>
                            :
                            <a className="btn btn-primary" href={"/" + preidioma + t("apartamentos") + "-" + hotel.destino.url_dinamica[lang] + "/" + hotel.url_dinamica}>{t("Ver apartamento")}</a>
                        }
                    </div >
                </div >
            </div >
        </div >
    );
};

export default HotelCard;
